$(document).ready(function() {
	// get reCAPTCHA site key from script URL
	var recaptcha_url = new URL($('#recaptcha-js').attr('src'));
	var recaptcha_site_key = recaptcha_url.searchParams.get('render');

	// find parking form functionality
	if ($('#autocomplete-form').length) {
		// get local timezone
		var today = new Date();
		var timezoneOffset = today.getTimezoneOffset();
		var offset = (timezoneOffset * 60) * -1;
		$('#address').attr('data-offset', offset);
		autocomplete();
		initialSearchForm();
	}

	if ($('#one-find-parking-form').length) {
		// get local timezone
		var today = new Date();
		var timezoneOffset = today.getTimezoneOffset();
		var offset = (timezoneOffset * 60) * -1;
		$('#one-find-parking-form-address').attr('data-offset', offset);
		oneParkingAutocomplete();
		oneParkingInitialSearchForm();
	}

	// sorry this is a big mess that needs to be rewritten
	function oneParkingAutocomplete(countries = ['us']) {
		var input = $('#one-find-parking-form-address')[0];
		var options = {
			componentRestrictions: {
				country: countries
			}
		};

		var autocomplete = new google.maps.places.Autocomplete(input, options);

		autocomplete.addListener('place_changed', function () {
			var place = autocomplete.getPlace();
			var lat = place.geometry.location.lat();
			var lng = place.geometry.location.lng();
			// convert offset to seconds
			var offset = place.utc_offset_minutes * 60;
			$(input).attr('data-latitude', lat).attr('data-longitude', lng).attr('data-offset', offset);
		});

		/*
		 * Removed 'Your Location' from input field if user focuses on it to search for an actual address.
		 * This prevents Google autocomplete from searching 'Your Location'.
		 */
		$(input).focus(function (e) {
			if (e.target.value === 'Your Location') {
				$(this).val('');
			}
		});
	}

	function oneParkingInitialSearchForm(type) {

		// allow choosing location with keyboard
		$('#one-find-parking-form-address').keydown(function (e) {
			if (e.which == 13 && $('.pac-container:visible').length) {
				return false;
			}
		});

		var autocompleteForm = $('#one-find-parking-form').validate({
			// debug: true,
			errorElement: 'span',
			errorClass: 'form-field-error',
			validClass: 'form-field-valid',
			errorPlacement: function (error, element) {
				error.appendTo(element.parents('form'));
			},
			highlight: function (element, errorClass, validClass) {
				$(element).parents('form').addClass(errorClass).removeClass(validClass);
			},
			unhighlight: function (element, errorClass, validClass) {
				$(element).parents('form').removeClass(errorClass).addClass(validClass);
			},
			rules: {
				'one-find-parking-form-address': {
					required: true
				}
			},
			messages: {
				'one-find-parking-form-address': {
					required: 'Please enter a place, address, or landmark.'
				}
			},
			submitHandler: function (form) {
				$('.button-spinner').prop('disabled', true);

				var parkingType = 'hourly';
				if ($('input[name="one-find-parking-form-parking-type"]', form).length > 0) {
					var parkingType = $('input[name="one-find-parking-form-parking-type"]:checked', form).val();
				} else if (type) {
					var parkingType = type;
				}

				console.log('parking type:', parkingType);

				var address = $('#one-find-parking-form-address').val();
				var offset = $('#one-find-parking-form-address').attr('data-offset');
				var latitude = $('#one-find-parking-form-address').attr('data-latitude');
				var longitude = $('#one-find-parking-form-address').attr('data-longitude');
				var nonce = $('#one-find-parking-form-nonce').val();

				console.log(latitude, longitude);

				if (latitude == 0 && longitude == 0) {
					// input has a value, but user hasn't selected a location from autocomplete
					autocompleteForm.showErrors({
						'address': 'Please choose a location from the dropdown menu.'
					});
					$('.button-spinner').prop('disabled', false);
				} else {
					var date = new Date();
					$.ajax({
						type: 'post',
						url: '/wp-admin/admin-ajax.php',
						data: {
							action: 'initial_search_query',
							parkingType: parkingType,
							address: address,
							latitude: latitude,
							longitude: longitude,
							startTime: GetTimeNearest30(date),
							startDate: GetDateStr(date),
							offset: offset,
							nonce: nonce
						},
						success: function (results) {
							var results = JSON.parse(results);
							console.log(results);
							if (results.status == 'success') {
								if (results.match == true) {
									var url = new URL(results.location.permalink);
									url.searchParams.set('type', results.parkingType);
									window.location.href = url.href;
								} else {
									var url = new URL(window.location.href);
									url.pathname = '/search/';
									url.searchParams.set('type', results.parkingType);
									url.searchParams.set('startDate', GetDateStr(date));
									url.searchParams.set('startTime', GetTimeNearest30(date));
									url.searchParams.set('lat', results.latitude);
									url.searchParams.set('lng', results.longitude);
									url.searchParams.set('address', encodeURIComponent(results.address));
									url.searchParams.set('offset', results.offset);
									console.log('url:', url);
									window.location.href = url.href;
								}
							} else {
								console.log('error!', results.message);
								$('.button-spinner').prop('disabled', false);
							}
						},
						error: function (results) {
							var results = JSON.parse(results);
							console.log(results);
							$('.button-spinner').prop('disabled', false);
						}
					});
				}
			}
		});
	}

	// find parking form modal
	$('.one-find-parking-modal-trigger').on('click', function(e) {
		e.preventDefault();
		$('body').addClass('one-find-parking-modal-active');
	});

	// click button to close modal
	$('.one-modal-button-close').on('click', function(e) {
		e.preventDefault();
		if ($('body').hasClass('one-find-parking-modal-active')) {
			$('body').removeClass('one-find-parking-modal-active');
		}
	});

	// hit esc key to close modal
	$(document).on('keydown', function(e) {
		if ($('body').hasClass('one-find-parking-modal-active') && e.keyCode == 27) {
			$('body').removeClass('one-find-parking-modal-active');
		}
	});

	// home template specific scripts
	if ($('body').hasClass('page-template-page-one-home')) {

		// change site header when scrolled away from the top
		if ($(this).scrollTop() > 0) {
			$('.site-header').addClass('site-header-active');
		} else {
			$('.site-header').removeClass('site-header-active');
		}

		$(window).scroll(function() {
			if ($(this).scrollTop() > 0) {
				$('.site-header').addClass('site-header-active');
			} else {
				$('.site-header').removeClass('site-header-active');
			}
		});

		// tagline words animation
		var words = $('.one-home-header-tagline-word');
		if (words.length > 1) {
			var words_index = words.length - 1;
			var index = 1;
			setInterval(function() {
				var word = words[index];
				$(words).removeClass('one-home-header-tagline-word-active');
				setTimeout(function() {
					$(word).addClass('one-home-header-tagline-word-active');
				}, 501);
				if (index >= words_index) {
					index = 0;
				} else {
					index++;
				}
			}, 3500);
		}

	}

	// expand/collapse accordion items
	var accordions = $('.one-accordion-group');
	$(accordions).each(function(index, accordion) {
		$('.one-accordion-item-title', accordion).on('click', function() {
			var this_item = $(this).parent();
			$('.one-accordion-item', accordion).not(this_item).removeClass('one-accordion-item-active');
			if ($(this_item).hasClass('one-accordion-item-active')) {
				$(this_item).removeClass('one-accordion-item-active');
			} else {
				$(this_item).addClass('one-accordion-item-active');
			}
		});
	});

	// expand/collapse team member biographies
	$('.one-team-member-title').on('click', function() {
		$(this).parents('.one-team-member').toggleClass('one-team-member-active');
	});

	// get number of decimals in a float
	function get_number_of_decimal_places(value) {
		if (Math.floor(value) === value) {
			return 0;
		}
		return value.toString().split('.')[1].length || 0;
	}

	// count up statistics from zero
	$('.one-v2-statistics-group').each(function(index, group) {
		var statistics = $('.one-v2-statistic', group);
		$(statistics).each(function(index, statistic) {
			var target = $('.one-v2-statistic-number', statistic)[0];
			var end_number = $(target).attr('data-number') * 1;
			var prefix = $(target).attr('data-prefix');
			var suffix = $(target).attr('data-suffix');
			var decimal_places = get_number_of_decimal_places(end_number);
			var options = {
				startVal: 0,
				decimalPlaces: decimal_places,
				duration: 3,
				useGrouping: true,
				useEasing: true,
				prefix: prefix,
				suffix: suffix,
				enableScrollSpy: true,
				scrollSpyOnce: true
			};
			var counter = new CountUp(target, end_number, options);
		});
	});

	// testimonials carousel
	$('.one-testimonial-carousel').each(function(index, group) {
		var cards = $('.one-testimonial-carousel-slides', group);
		var pager = $('.one-carousel-controls-pager', group);
		var previous_link = $('.one-carousel-controls-link-prev', group);
		var next_link = $('.one-carousel-controls-link-next', group);
		var carousel = $(cards).flickity({
			adaptiveHeight: false,
			cellAlign: 'center',
			contain: true,
			pageDots: false,
			percentPosition: true,
			prevNextButtons: false,
			wrapAround: true
		});
		$('.one-carousel-controls-pager a', group).on('click', function(e) {
			e.preventDefault();
			var index = $(this).attr('data-slide-index');
			$('.one-carousel-controls-pager a', group).removeClass('active');
			$(this).addClass('active');
			carousel.flickity('select', index, true, false);
		});
		$('.one-carousel-controls-link-prev', group).on('click', function(e) {
			e.preventDefault();
			carousel.flickity('previous', true, false);
			var data = carousel.data('flickity');
			$('.one-carousel-controls-pager a', group).removeClass('active');
			$('.one-carousel-controls-pager a[data-slide-index="' + data.selectedIndex + '"]', group).addClass('active');
		});
		$('.one-carousel-controls-link-next', group).on('click', function(e) {
			e.preventDefault();
			carousel.flickity('next', true, false);
			var data = carousel.data('flickity');
			$('.one-carousel-controls-pager a', group).removeClass('active');
			$('.one-carousel-controls-pager a[data-slide-index="' + data.selectedIndex + '"]', group).addClass('active');
		});
	});

	// filter out facility options based on selected state
	$('.garage-location-input select').on('change', function() {
		var selected_state = $(this).val();
		var facilities = $('.garage-input option');
		$(facilities).each(function(index, facility) {
			$(facility).show().prop('disabled', false);
			var facility_state = $(facility).attr('data-state');
			if (facility_state !== selected_state) {
				$(facility).hide().prop('disabled', true);
			}
		});
		$('.garage-input option.gf_placeholder').prop('selected', true);
	});

	// filter and sort property cards
	if ($('.one-v2-properties-cards-group-mixitup').length) {
		var mixer = mixitup('.one-v2-properties-cards-group-mixitup', {
			animation: {
				effects: 'fade scale',
				duration: 500,
				easing: 'ease-in-out'
			},
			debug: {
				enable: true
			},
			load: {
				sort: 'order:asc'
			},
			multifilter: {
				enable: true
			},
			selectors: {
				target: '.one-v2-properties-card-wrapper'
			}
		});
	}

	// log in form functionality
	if ($('#one-login-box-form').length > 0) {
		var form = $('#one-login-box-form');
		$('#login-box-state', form).on('change', function() {
			var state = $(this).val();
			$('#login-box-facility option', form).prop({ hidden: false, disabled: false });
			$('#login-box-facility option[value="#"]', form).prop({ selected: true });
			$('#login-box-facility option', form).not('[value="#"]').not('[data-state="' + state + '"]').prop({ hidden: true, disabled: true });
			$('#form-field-facility', form).show();
		});
		$('#login-box-facility', form).on('change', function() {
			var provider = $(this).val();
			console.log(provider);
			if (provider === 'parkchirp') {
				$('#form-field-parkerbill-button', form).hide();
				$('#form-field-parkchirp-form', form).show();
				// $('#one-account-management-links').show();
			} else if (provider === 'parkerbill') {
				$('#form-field-parkchirp-form', form).hide();
				$('#form-field-parkerbill-button', form).show();
				// $('#one-account-management-links').hide();
			}
		});
	}

	// duplicate log in form
	$('#aws-cognito-log-in-alt').validate({
		// debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('.form-field'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
		},
		'rules': {
			'login-email-address-alt': {
				required: true,
				email: true
			},
			'login-password-alt': {
				required: true
			}
		},
		'messages': {
			'login-email-address-alt': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			},
			'login-password-alt': {
				required: 'Please enter your password.'
			}
		},
		submitHandler: function (form) {
			// enable spinner animation on submit button
			$('.button-spinner', form).prop('disabled', true);

			grecaptcha.ready(function () {
				grecaptcha.execute(recaptcha_site_key, { action: 'aws_cognito_log_in' }).then(function (token) {
					// get all the variables
					var email_address = $('#login-email-address-alt', form).val();
					var password = $('#login-password-alt', form).val();
					// var nonce = $('#aws-cognito-log-in-nonce-alt', form).val();

					// do something with them!
					$.ajax({
						type: 'post',
						url: '/wp-admin/admin-ajax.php',
						data: {
							action: 'aws_cognito_log_in',
							email_address: email_address,
							password: password,
							recaptcha_token: token
							// nonce: nonce
						},
						success: function (results) {
							var results = JSON.parse(results);
							// console.log(results);
							if (results.status === 'success') {
								// regular log in with email and password with no MFA
								var redirect_url = $(form).attr('data-redirect-url');
								if (redirect_url) {
									if (redirect_url === 'reload') {
										setTimeout(function () {
											location.reload();
										}, 250);
									} else {
										setTimeout(function () {
											window.location.href = redirect_url;
										}, 250);
									}
								}
								$('.form-card-message', form).empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
							} else if (results.status === 'error') {
								$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
							} else {
								$('.form-card-message', form).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something happened?');
							}
							// disable spinner animation on submit button
							$('.button-spinner', form).prop('disabled', false);
						},
						error: function (results) {
							// var results = JSON.parse(results);
							console.log(results);
							// disable spinner animation on submit button
							$('.button-spinner', form).prop('disabled', false);
						}
					});
				});
			});
		}
	});

});
